// extracted by mini-css-extract-plugin
export default {"element":"RaceStats_element__cNG0V"};